var _path, _ellipse, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4612 12.733C48.7297 12.7975 48.9997 12.6322 49.0642 12.3637C49.1287 12.0952 48.9633 11.8252 48.6948 11.7607L48.4612 12.733ZM47.8116 51.9373L47.6948 51.4511L47.8116 51.9373ZM23.8116 57.7036L23.9284 58.1898L23.8116 57.7036ZM23.8116 6.29639L23.9284 5.81023L23.8116 6.29639ZM22.078 7.26872V56.7313H23.078V7.26872H22.078ZM23.9284 58.1898L47.9284 52.4234L47.6948 51.4511L23.6948 57.2174L23.9284 58.1898ZM48.6948 11.7607L23.9284 5.81023L23.6948 6.78256L48.4612 12.733L48.6948 11.7607ZM49.078 50.9649V31.5H48.078V50.9649H49.078ZM47.9284 52.4234C48.6027 52.2614 49.078 51.6584 49.078 50.9649H48.078C48.078 51.1961 47.9196 51.3971 47.6948 51.4511L47.9284 52.4234ZM22.078 56.7313C22.078 57.7015 22.9851 58.4164 23.9284 58.1898L23.6948 57.2174C23.3804 57.293 23.078 57.0547 23.078 56.7313H22.078ZM23.078 7.26872C23.078 6.94533 23.3804 6.70701 23.6948 6.78256L23.9284 5.81023C22.9851 5.58358 22.078 6.29855 22.078 7.26872H23.078Z",
    fill: "#051B46"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7108,
    cy: 32,
    rx: 1.33333,
    ry: 2,
    fill: "#051B46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.578 51.2346H15C14.4477 51.2346 14 50.7869 14 50.2346V13.7617C14 13.2094 14.4477 12.7617 15 12.7617H22.578",
    stroke: "#051B46",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5779 33.1963L48.5779 18.1963M48.5779 18.1963L43.5779 23.6508M48.5779 18.1963L53.5779 23.6508",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomUpload);
export default __webpack_public_path__ + "static/media/room-upload.939e44767d99dec7d97d0754c3594744.svg";
export { ForwardRef as ReactComponent };